<template>
    <!-- 限价计划 -->
    <div class="receipt-list-view">
        <Row type="flex">
            <div class="flex-child">
                选择部门：
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="search.department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                计划版本：
                <Select v-model="search.version" style="width:100px;">
                    <Option v-for="item in planVersion" :key="item.versionName" :value="item.versionName">{{ item.versionName }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                计划类型：
                <Select v-model="search.type" style="width:100px;" @on-change="filterPlanType" clearable>
                    <Option v-for="item in planType" :key="item.typeName" :value="item.typeName">{{ item.typeName }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                <span>计划期：</span>
                <DatePicker
                    v-if="search.type === '日' || search.type === ''"
                    type="date"
                    format="yyyy-MM-dd"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '周'"
                    type="date"
                    :format="'yyyy-MM 第' + queryWeek + '周'"
                    value-format="yyyy-MM-dd"
                    @on-change="weekChange"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '月'"
                    type="month"
                    format="yyyy-MM"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '年'"
                    type="year"
                    format="yyyy"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
            </div>
            <div class="flex-child">
                计划单号：
                <Input placeholder="请输入计划单号"
                    style="width: 160px"
                    v-model="search.projectId"/>
            </div>
            <div class="flex-child">
                <Button type="primary" :loading="checkLoading">
                    <span v-if="!checkLoading" @click="lookSearch">查询</span>
                    <span v-else>查询</span>
                </Button>
                <Button @click="resetData">重置</Button>
            </div>
        </Row>
         <!-- 表格 -->
        <Table :columns="columns" :data="list" :height="500">
            <template slot-scope="{ row }" slot="action">
                <div>
                    <Button size="small"
                        @click="handleClick(row, 1)">查看</Button>
                    <Button size="small" type="primary"
                        v-if="row.projectStatus === '已发布'"
                        @click="handleClick(row, 4)"
                        style="margin-left: 6px;">供应</Button>
                </div>
            </template>
        </Table>
         <!-- 分页 -->
        <div class="pages-box">
            <Page
                :current="pager.currentPage"
                :total="pageTotal"
                show-sizer
                :page-size="pager.pageSize"
                @on-change="getChangePageNum"
                @on-page-size-change="getChangePageSize"/>
        </div>
        <Modal
            class="model-postion-setting"
            v-model="dialog"
            title="确认">
            <div class="history-order">
                <span>确定要吗?</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="dialog = false">取消</span>
                <span class="his-ok" @click="submit">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { getAllProjects, getProjectVersion, getProjectType } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        const self = this;
        return {
            search: {
                department: [],
                organNo: '',
                projectId: '',
                version: '',
                type: '',
                period: '',
                cgType: ''
            },
            departmentData: [],
            timeOut: null,
            planVersion: [],
            planType: [],
            queryWeek: '',
            selectPeriod: '',
            checkLoading: false,
            columns: [
                {
                    title: '操作',
                    slot: 'action',
                    width: 140,
                    align: 'center'
                },
                {
                    align: 'left',
                    key: 'organNo',
                    title: '单位',
                    minWidth: 160
                },
                {
                    align: 'left',
                    key: 'projectId',
                    title: '计划单号',
                    width: 160
                },
                {
                    align: 'left',
                    key: 'quotationNo',
                    title: '询价单号',
                    width: 140
                },
                {
                    align: 'center',
                    key: 'isUpdated',
                    title: '是否调整',
                    render(h, data) {
                        return h('span', {
                            class: [data.row.isUpdated ? 'diff-color' : '']
                        }, data.row.isUpdated ? '是' : '否');
                    },
                    className: 'isUpdated',
                    width: 90
                },
                {
                    align: 'center',
                    key: 'isLocked',
                    title: '是否锁定',
                    render(h, data) {
                        return h('span', {
                            class: [data.row.isLocked ? 'error-color' : '']
                        }, data.row.isLocked ? '是' : '否');
                    },
                    width: 90
                },
                {
                    align: 'center',
                    key: 'projectStatus',
                    title: '状态',
                    width: 90
                },
                {
                    align: 'center',
                    key: 'version',
                    title: '计划版本',
                    width: 90
                },
                {
                    align: 'center',
                    key: 'type',
                    title: '计划类型',
                    width: 90
                },
                {
                    align: 'center',
                    key: 'period',
                    title: '计划期',
                    minWidth: 100
                }
            ],
            list: [],
            pageTotal: 0,
            pager: {
                currentPage: 1,
                pageSize: 20
            },
            dialog: false
        };
    },
    mounted() {
        this.getAllOrganList();
        this.getProjectVersion();
        this.getProjectType();
        setTimeout(() => {
            this.getList();
        });
    },
    methods: {
        lookSearch() {
            this.pager.currentPage = 1;
            this.checkLoading = true;
            this.getList();
        },
        resetData() {
            this.pager.currentPage = 1;
            this.search.projectId = '';
            this.getList();
        },
        getList() {
            this.$apollo.query({
                query: getAllProjects,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                    projectId: this.search.projectId,
                    organNo: this.search.organNo,
                    version: this.search.version,
                    type: this.search.type,
                    period: this.selectPeriod,
                    pageNumber: this.pager.currentPage,
                    pageSize: this.pager.pageSize
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                this.checkLoading = false;
                const result = res.data.getAllProjects;
                if (result.code === 200) {
                    this.list = result.data;
                    this.pageTotal = result.pager.totalItems;
                }
            }).catch(error => {
                if (error) {
                    this.$setNotice('服务繁忙，请稍后刷新');
                }
            });
        },
        getChangePageNum(val) {
            this.pager.currentPage = val;
            this.getList();
        },

        // 分页显示条数改变
        getChangePageSize(val) {
            this.pager.pageSize = val;
            this.getList();
        },
        // 表格操作
        handleClick(row, ty) {
            if (ty === 1) {
                this.$router.push({
                    path: '/index/plan_price/detail',
                    query: {
                        projectId: row.projectId,
                        isUpdated: row.isUpdated ? '1' : '2'
                    }
                });
            } else if (ty === 4) {
                // 供应
                this.$router.push({
                    path: '/index/manualBuild/stepSecond',
                    query: {
                        projectId: row.projectId,
                        type: 'jh',
                        isLocked: row.isLocked ? '1' : '2'
                    }
                });
            }
        },
        submit() {},
        // 获取部门列表
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },

        // 选中部门
        getCascader(val) {
            this.search.organNo = val[val.length - 1] || '';
        },
        getProjectVersion() {
            this.$apollo.query({
                query: getProjectVersion,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getProjectVersion;
                if (result.code === 200) {
                    this.planVersion = result.data;
                }
            }).catch(error => {
                if (error) {
                    this.$setNotice('服务繁忙，请稍后刷新');
                }
            });
        },
        getProjectType() {
            this.$apollo.query({
                query: getProjectType,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getProjectType;
                if (result.code === 200) {
                    this.planType = result.data;
                }
            }).catch(error => {
                if (error) {
                    this.$setNotice('服务繁忙，请稍后刷新');
                }
            });
        },
        filterPlanType(data) {
            if (data) {
                this.selectPeriod = '';
                this.search.period = '';
                if (data === '周') {
                    this.getDay();
                }
            } else {
                this.search.type = '';
                this.selectPeriod = '';
                this.search.period = '';
            }
        },
        filterPeriod(data) {
            this.selectPeriod = data.replace(/-/g, '');
        },
        // 初始化日期
        getDay() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            const nowDay = `${year}-${month}-${day}`;
            this.queryWeek = this.getWeekInMonth(new Date(nowDay));
            this.search.period = `${year}-${month}-${day}`;
            this.selectPeriod = `${year}-${month}-0${this.queryWeek}`;
            this.selectPeriod = this.selectPeriod.replace(/-/g, '');
        },
        weekChange(val) {
            const date = this.search.period.toLocaleDateString().replace(/\//g, '-');
            const date1 = new Date(date);
            const year = date1.getFullYear();
            let month = date1.getMonth() + 1;
            let day = date1.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            this.search.period = `${year}-${month}-${day}`;
            if (val) {
                this.queryWeek = this.getWeekInMonth(new Date(date));
            }
            this.selectPeriod = `${year}-${month}-0${this.queryWeek}`;
            this.selectPeriod = this.selectPeriod.replace(/-/g, '');
        },
        // 根据日期判断是月的第几周
        getWeekInMonth(t) {
            let newT = t;
            if (newT === undefined || newT === '' || newT === null) {
                newT = new Date();
            } else {
                const nt = new Date();
                nt.setYear(newT.getFullYear());
                nt.setMonth(newT.getMonth());
                nt.setDate(newT.getDate());

                const date = nt.getDate(); // 给定的日期是几号

                nt.setDate(1);
                const d = nt.getDay(); // 1. 得到当前的1号是星期几。
                let fisrtWeekend = d;
                if (d === 0) {
                    fisrtWeekend = 1;
                    // 1号就是星期天
                } else {
                    fisrtWeekend = (7 - d) + 1; // 第一周的周未是几号
                }
                if (date <= fisrtWeekend) {
                    return 1;
                }
                if (date > fisrtWeekend) {
                    return 1 + Math.ceil((date - fisrtWeekend) / 7);
                }
            }
            return '';
        },
        getArrValue(value, arr) {
            let key = '';
            arr.forEach(item => {
                if (value === item.value) {
                    key = item.label;
                }
            });
            return key;
        }
    }
};
</script>

<style scoped lang="stylus">

@import '../../assets/stylus/views/receipt-list.styl'

</style>



// WEBPACK FOOTER //
// src/views/PlanPrice/index.vue